module.exports = __webpack_public_path__ + "static/media/CloseIcon.56d567fe.svg";